import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import DefaultForm from '../DefaultForm';
import { useFormRemoveArea } from '../hooks/useFormRemoveArea';

const DefaultFormCRemoveArea = (props) => {
	const {
		isPlain,
		onSubmit,
		onCancel,
		serverError,
		options,
		fullHeight,
		...rest
	} = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormRemoveArea({
		options,
	});

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Открепить площадку"
						acceptLabel="Открепить"
						fullHeight={fullHeight}
						error={serverError}
						onSubmit={formikProps.handleSubmit}
						onCancel={onCancel}
						onAccept={formikProps.submitForm}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCRemoveArea.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.string,
		}),
	),
};

export default DefaultFormCRemoveArea;
